import {apiClient} from "@/services/client";


export const sendHelpRequest = (form: any) => {
    return apiClient.post(`/communication/contact`,form);
}


export const subscribe = (email: any) => {

    return apiClient.post(`/communication/subscribe`,{'email': email});
}


export const getCurrencies = () => {

    return apiClient.get(`currency`);
}


